export type ShinkansenTicketPickupNotice = {
  title: string;
  descriptionLines: string[];
  noteLine: string;
  bulletLines: string[];
  phoneNumber?: string;
  manualUrl: string;
  manualLabel: string;
};

const COMMON_BULLET_LINES = [
  '・往路の出発駅でご依頼分【すべて（往路＋復路）】のチケットをお受け取りください',
  '・往路分だけを受け取った後、復路分を帰りの駅／乗り継ぎ駅で受け取ることができません',
  '・上記に沿わない場合、ご予約いただいた内容でご乗車いただくことができなくなります'
];

export const buildShinkansenTicketPickupNotice = (
  ticketingMethod?: string | null
): ShinkansenTicketPickupNotice | null => {
  switch (ticketingMethod) {
    case 'qr_west':
      return {
        title: '【新幹線チケット受け取りについて】',
        descriptionLines: [
          'e5489でご予約の新幹線チケットは、',
          '発券機でQRコードを読み取り後、電話番号の入力を求められます。'
        ],
        noteLine: '※チケットは「往路の出発駅」で受け取る必要があります',
        bulletLines: COMMON_BULLET_LINES,
        phoneNumber: '0344055753',
        manualUrl:
          'https://aitravel.my.salesforce.com/sfc/p/#7F000002CrgE/a/TL000009oClZ/WjqKmA7UVdktcrsHXT8knfBL5_EIgQ0Ie8aNma_Epvw',
        manualLabel: 'e5489チケットご利用マニュアル'
      };
    case 'qr_east':
      return {
        title: '【新幹線チケット受け取りについて】',
        descriptionLines: [],
        noteLine: 'チケットは「往路の出発駅」で受け取る必要があります',
        bulletLines: COMMON_BULLET_LINES,
        manualUrl:
          'https://aitravel.my.salesforce.com/sfc/p/#7F000002CrgE/a/TL000009oCSD/60BPpg_FMjI78FC9EbT7_gTD17p8dxYsLytkC6I9gug',
        manualLabel: 'ビジネスえきねっとチケットご利用マニュアル'
      };
    default:
      return null;
  }
};
